import { createSelector } from "reselect"
import env from "../../../../env"
import { workspaceUrl } from "../../../../util/UrlGenerator"
import {
    INavigation,
    INavigationItem,
    INavigationSmartlistGroup,
    INavigationWorkspaceGroup,
    ISmartlists,
    IWorkspaces,
} from "./index"
import { NavigationWorkspaceChild, Smartlist } from "../../../../models"

const applicationPath = env.applicationPath

export interface IsLoading {
    isLoading: boolean
}

const getSmartlists = (state: INavigation): ISmartlists => state.smartlists

const smartlistToNavigationItem = (
    smartlist: Smartlist,
    group: string,
): INavigationItem => ({
    label: smartlist.WorkspaceLabel,
    text: smartlist.Label,
    url: applicationPath + smartlist.Url,
    group,
})

export interface VisibileSmartlistGroups {
    smartlistGroups: INavigationSmartlistGroup[]
}

export const getSmartlistGroups = createSelector(
    [getSmartlists],
    (smartlists): INavigationSmartlistGroup[] => {
        const { Private, SharedByMe, SharedWithMe } = smartlists
        return [
            {
                type: "private",
                hasMore: Private.hasMore,
                isLoading: Private.isLoading,
                smartlists: Private.smartlists.map((x) =>
                    smartlistToNavigationItem(x, "private"),
                ),
            },
            {
                type: "sharedByMe",
                hasMore: SharedByMe.hasMore,
                isLoading: SharedByMe.isLoading,
                smartlists: SharedByMe.smartlists.map((x) =>
                    smartlistToNavigationItem(x, "sharedByMe"),
                ),
            },
            {
                type: "sharedWithMe",
                hasMore: SharedWithMe.hasMore,
                isLoading: SharedWithMe.isLoading,
                smartlists: SharedWithMe.smartlists.map((x) =>
                    smartlistToNavigationItem(x, "sharedWithMe"),
                ),
            },
        ]
    },
)

export const getVisibleSmartlistGroups = createSelector(
    [getSmartlistGroups],
    (smartlistGroups): INavigationSmartlistGroup[] =>
        smartlistGroups.filter((group) => group.smartlists.length > 0),
)

export const areSmartlistsLoading = createSelector(
    [getSmartlistGroups],
    (smartlistGroups): boolean => {
        return smartlistGroups.every((group) => group.isLoading)
    },
)

const getStructure = (state: INavigation): IWorkspaces => state.workspaces
const workspaceChildToNavigationItem = (
    child: NavigationWorkspaceChild,
    group: string,
): INavigationItem => ({
    group: group,
    isSmartlist: child.IsSmartlist,
    text: child.Label,
    url: applicationPath + child.Url,
})

export interface NavigationWorkspaces {
    navigationWorkspaces: INavigationWorkspaceGroup[]
}

export const getNavigationWorkspaces = createSelector(
    [getStructure],
    (structure): INavigationWorkspaceGroup[] => {
        const { workspaces } = structure

        return !workspaces
            ? []
            : workspaces.map((workspace) => {
                  return {
                      id: workspace.Id,
                      label: workspace.Label,
                      url: workspaceUrl(applicationPath, workspace),
                      workspaceChildren: workspace.Children
                          ? workspace.Children.map(
                                (child: NavigationWorkspaceChild) =>
                                    workspaceChildToNavigationItem(
                                        child,
                                        workspace.Id.toString(),
                                    ),
                            )
                          : [],
                  }
              })
    },
)
